/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './AgentSeriesFare.scss';
import add from 'date-fns/add';
import AppButton from '../../../shared/components/app-button/AppButton';
import AddCoupon from './AddCoupon';
import AgentSeriesFare from './AgentSeriesFare';
import SeriesTransactions from './SeriesTransactions';
import SeriesSaleReport from './SeriesSaleReport';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { getAgentCouponApi } from '../../../api/profileApi';
import {
  getCurrentAvailCouponDetailForAgent,
  getFlightSeriesListForSeriesOwner,
} from '../../../api/flightApi';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import SeriesCurrentAvailability from './SeriesCurrentAvailability';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import SeriesNameReport from './SeriesNameReport';
import AccountsPageHorizontalBar from '../accounts/AccountsPageHorizontalBar';

const SERIES_TX_LIST = 'series_tx_list';
const SURF_COUPONS = 'surf_coupon';
const ADD_COUPON = 'add_coupon';
const SALE_REPORT = 'sale_report';
const AVAILABILITY = 'availability';
const NAME_LIST = 'name_list';

function AgentSeriesFarePage() {
  const [selectedTab, setSelectedTab] = useState(SERIES_TX_LIST);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const allCouponsRef = useRef([]);
  const availableCouponsRef = useRef([]);
  const seriesTransactionsListRef = useRef([]);
  const [selectedCouponForClone, setCouponForClone] = useState(undefined);

  const getInitData = async () => {
    setIsLoading(true);
    try {
      const allCouponsRes = await getAgentCouponApi();
      if (allCouponsRes?.Root?.Status === 'OK') {
        const { CouponMaster } = allCouponsRes.Root?.Result;
        if (
          CouponMaster !== '' &&
          CouponMaster !== undefined &&
          CouponMaster !== null
        ) {
          const list = Array.isArray(CouponMaster)
            ? CouponMaster
            : [CouponMaster];
          allCouponsRef.current = list;
        }
      }
      const currentAvailRes = await getCurrentAvailCouponDetailForAgent(
        getUserAgentId(),
      );
      if (
        currentAvailRes &&
        currentAvailRes.Root &&
        currentAvailRes.Root.Status === 'OK'
      ) {
        const { CouponFlightDetailList } = currentAvailRes.Root?.Result;
        if (
          CouponFlightDetailList !== '' &&
          CouponFlightDetailList !== undefined &&
          CouponFlightDetailList !== null
        ) {
          const { CouponFlightDetails } = CouponFlightDetailList;
          if (!isEmpty(CouponFlightDetails)) {
            const list = Array.isArray(CouponFlightDetails)
              ? CouponFlightDetails
              : [CouponFlightDetails];
            availableCouponsRef.current = list;
          }
        }
      }
      const formattedTodayDate = formatDate(
        getNewDate(TODAY_DATE),
        API_DATE_FORMAT,
      );
      const formattedTomorrowDate = formatDate(
        getNewDate(add(getNewDate(TODAY_DATE), { days: 1 })),
        API_DATE_FORMAT,
      );
      const txListResponse = await getFlightSeriesListForSeriesOwner(
        formattedTodayDate,
        formattedTomorrowDate,
        getUserAgentId(),
      );
      if (
        txListResponse &&
        txListResponse.Root &&
        txListResponse.Root.Status === 'OK'
      ) {
        if (
          !isEmpty(txListResponse.Root.Result) &&
          !isEmpty(txListResponse.Root.Result.SeriesFarePaxNameDetails) &&
          !isEmpty(
            txListResponse.Root.Result.SeriesFarePaxNameDetails
              .SeriesFarePaxNameDetail,
          )
        ) {
          const list = Array.isArray(
            txListResponse.Root.Result.SeriesFarePaxNameDetails
              .SeriesFarePaxNameDetail,
          )
            ? txListResponse.Root.Result.SeriesFarePaxNameDetails
                .SeriesFarePaxNameDetail
            : [
                txListResponse.Root.Result.SeriesFarePaxNameDetails
                  .SeriesFarePaxNameDetail,
              ];
          seriesTransactionsListRef.current = list;
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInitData();
  }, []);

  const handleClone = (coupon) => {
    setCouponForClone(coupon);
    setSelectedTab(ADD_COUPON);
  };

  const handleSelectTab = (tab) => {
    if (selectedTab === ADD_COUPON) {
      setCouponForClone(undefined);
    }
    setSelectedTab(tab);
  };

  const handlegetAllCoupons = async () => {
    setIsLoading(true);
    try {
      const allCouponsRes = await getAgentCouponApi();
      if (allCouponsRes?.Root?.Status === 'OK') {
        const { CouponMaster } = allCouponsRes.Root?.Result;
        if (
          CouponMaster !== '' &&
          CouponMaster !== undefined &&
          CouponMaster !== null
        ) {
          const list = Array.isArray(CouponMaster)
            ? CouponMaster
            : [CouponMaster];
          allCouponsRef.current = list;
        }
      }
      setIsLoading(false);
      handleSelectTab(SURF_COUPONS);
    } catch (error) {
      setIsLoading(false);
      handleSelectTab(SURF_COUPONS);
    }
  };

  return (
    <>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      <section className="agent-series-fare">
        <AccountsPageHorizontalBar selectedTab="agent-series-fare" />
        <Row className="max-width">
          <Col lg={10}>
            <section className="agent-series-fare_container">
              <div className="agent-series-fare_header">
                Agent series Fare coupons
              </div>
              <div className="p-3">
                <div className="d-flex gap-2 fs-14 flex-wrap">
                  <AppButton
                    btnText="Series Transactions"
                    variant={
                      selectedTab === SERIES_TX_LIST ? 'primary' : 'outlined'
                    }
                    onClick={() => handleSelectTab(SERIES_TX_LIST)}
                  />
                  <AppButton
                    btnText="View Coupons"
                    variant={
                      selectedTab === SURF_COUPONS ? 'primary' : 'outlined'
                    }
                    onClick={() => handleSelectTab(SURF_COUPONS)}
                  />
                  <AppButton
                    btnText="Add Coupons"
                    variant={
                      selectedTab === ADD_COUPON ? 'primary' : 'outlined'
                    }
                    onClick={() => handleSelectTab(ADD_COUPON)}
                  />
                  <AppButton
                    btnText="Sale Report"
                    variant={
                      selectedTab === SALE_REPORT ? 'primary' : 'outlined'
                    }
                    onClick={() => handleSelectTab(SALE_REPORT)}
                  />
                  <AppButton
                    btnText="Current Availability"
                    variant={
                      selectedTab === AVAILABILITY ? 'primary' : 'outlined'
                    }
                    onClick={() => handleSelectTab(AVAILABILITY)}
                  />
                  <AppButton
                    btnText="Series Name List"
                    variant={selectedTab === NAME_LIST ? 'primary' : 'outlined'}
                    onClick={() => handleSelectTab(NAME_LIST)}
                  />
                </div>
                <div>
                  {selectedTab === SERIES_TX_LIST && (
                    <SeriesTransactions
                      defaultList={seriesTransactionsListRef.current}
                    />
                  )}
                  {selectedTab === SURF_COUPONS && (
                    <AgentSeriesFare
                      allCouponsList={allCouponsRef.current}
                      onClone={handleClone}
                    />
                  )}
                  {selectedTab === ADD_COUPON && (
                    <AddCoupon
                      cloneCoupon={selectedCouponForClone}
                      onRefreshForNewCoupons={handlegetAllCoupons}
                    />
                  )}
                  {selectedTab === SALE_REPORT && <SeriesSaleReport />}
                  {selectedTab === AVAILABILITY && (
                    <SeriesCurrentAvailability
                      availableList={availableCouponsRef.current}
                    />
                  )}
                  {selectedTab === NAME_LIST && <SeriesNameReport />}
                </div>
              </div>
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
}

export default AgentSeriesFarePage;
